export const FDA_REGULATIONS_LINK: string =
  'https://www.fda.gov/food/environmental-contaminants-food/closer-zero-reducing-childhood-exposure-contaminants-foods';
